/* globals STATIC_URL */
import React from 'react';
import { connect } from 'react-redux';
import { Row, Columns } from 'views/Grid';
import OfferContainer from './OfferContainer';
import DescriptionBlock from './DescriptionBlock';
import LinksRibbon from './LinksRibbon';

import {
  getImagePreview,
} from '../../reducers/ProductReducers';

const Portrait = ({ preview }) => {
  return (
    <div>
      <div className="background-white portrait__header-block">
        <Row className="collapse">
          <Columns className="medium-6 show-for-medium">
            <div className="soft--ends soft--left">
              <div className="portrait-image-center-cropped"
                style={{ backgroundImage: preview ? `url(${preview})` : `url(${STATIC_URL}assets/images/no-image.png)` }}>
              </div>
            </div>
          </Columns>
          { preview ?
            <Columns className="small-12 show-for-small-only">
              <div className="portrait-image-center-cropped"
                style={{ backgroundImage: `url(${preview})` }}>
              </div>
            </Columns> :
            null
          }
          <Columns className="small-12 medium-6">
            <OfferContainer />
          </Columns>
        </Row>
      </div>
      <LinksRibbon />
      <DescriptionBlock />
    </div>
  );
};

const mapStateToProps = ({ product }) => ({
  preview: getImagePreview(product),
});

export default connect(mapStateToProps)(Portrait);



// WEBPACK FOOTER //
// ./src/product/views/_layout/Portrait.js